import { stats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20abstract%20background%20of%20glowing%20watermelon%20slices%20and%20sparkling%20stars%20on%20deep%20crimson%20red%20night%20sky%2C%20modern%20young%20community%20celebration%20party%20atmosphere%2C%20neon%20light%20accents%2C%20rich%20dark%20background%20with%20warm%20red%20and%20soft%20green%20glow%20highlights%2C%20no%20text&width=1600&height=900&seq=hero-watermelon-night-2026&orientation=landscape"
          alt="嗑瓜星球吃瓜社区开席背景"
          title="国产吃瓜社区讨论开席"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-900/60 to-background-50"></div>
      </div>

      <div className="container-site relative z-10 flex flex-col items-center pb-16 pt-28 text-center md:pt-36">
        <span className="animate-pop inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/15 px-4 py-1.5 text-xs font-semibold text-background-50 backdrop-blur-sm">
          <span className="flex h-2 w-2 items-center justify-center">
            <span className="h-2 w-2 rounded-full bg-secondary-400 animate-pulse"></span>
          </span>
          全网瓜友正在热聊 · 评论区 / 群聊 / 树洞全天候开放
        </span>

        <h1 className="mt-6 max-w-3xl text-4xl font-black leading-tight text-background-50 md:text-6xl md:leading-[1.15]">
          今晚的瓜<span className="font-display text-secondary-400">·</span>这届网友抢先吃
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          国产吃瓜社区与论坛聚集地。来加入国产吃瓜讨论，看各路网友实时热评与爆料补充，一起聊最新话题——找同好、对暗号、蹲后续，互动氛围直接拉满。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#hot"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-bold text-background-50 shadow-lift transition hover:-translate-y-0.5 hover:bg-primary-400"
          >
            🔥 看实时热榜
          </a>
          <a
            href="#treehole"
            className="whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-7 py-3.5 text-sm font-bold text-background-50 backdrop-blur-sm transition hover:bg-background-50/20"
          >
            逛逛深夜树洞
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-px overflow-hidden rounded-2xl border border-background-50/20 bg-background-50/10 backdrop-blur-md sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-1 bg-primary-950/30 px-3 py-5">
              <span className="text-2xl font-black text-secondary-400 md:text-3xl">{s.value}</span>
              <span className="text-xs text-background-100/90">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}